import { BaseService } from "services/_baseService";

class VendorsAdminService extends BaseService<any> {
  constructor() {
    super(`vendors`);
  }
}

export default new VendorsAdminService();
